import { useEffect, useRef } from 'react'

import { useUpdateUserActivationDataMutation } from 'common'

import { patchBrandRefreshActivationData } from './brandRefreshActivationData'
import { useBrandRefreshActivationData } from './useBrandRefreshActivationData'

/**
 * Persists the banner impression timestamp to `activation_data.brand_refresh_beta`.
 * Writes once when the banner is first shown and `banner_started_at` is unset.
 */
export function useRecordBrandRefreshBannerStartedAt(shouldRecord: boolean) {
  const { blob, isLoading } = useBrandRefreshActivationData({ skip: !shouldRecord })
  const [updateActivationData] = useUpdateUserActivationDataMutation()
  const hasRequestedRef = useRef(false)

  useEffect(() => {
    if (!blob.banner_started_at) {
      hasRequestedRef.current = false
    }
  }, [blob.banner_started_at])

  useEffect(() => {
    if (!shouldRecord || isLoading || hasRequestedRef.current) {
      return
    }

    const existing = blob.banner_started_at
    if (typeof existing === 'string' && existing.length > 0) {
      return
    }

    hasRequestedRef.current = true
    const startedAt = new Date().toISOString()

    updateActivationData((activationData) => patchBrandRefreshActivationData(
      activationData,
      { banner_started_at: startedAt },
    ))
  }, [blob.banner_started_at, isLoading, shouldRecord, updateActivationData])
}
